import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

export default function CustomTable({ columns, data }) {
  return (
    <TableContainer sx={{ maxWidth: "100%", overflowX: "auto" }}>
      <Table sx={{ borderCollapse: "collapse", minWidth: 300 }}>
        <TableHead>
          <TableRow>
            {columns.map((col, idx) => (
              <TableCell
                key={idx}
                align="center"
                colSpan={col === "VALOR" || col === "VALUE" ? 2 : 1} // 👈 ocupa 2 columnas solo si es "VALOR"
                sx={{
                  fontWeight: 700,
                  fontFamily: "Montserrat",
                  fontSize: "18px",
                  color: "#1B2466",
                  borderBottom: "2px solid #1B2466",
                  borderTop: "none",
                  borderLeft: "none",
                  borderRight: "none",
                  letterSpacing: "-0.133px",
                }}
              >
                {col}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, rowIndex) => (
            <TableRow key={rowIndex}>
              {row.map((cell, cellIndex) => (
                <TableCell
                  key={cellIndex}
                  align="center"
                  sx={{
                    fontWeight: 400,
                    fontFamily: "Montserrat",
                    fontSize: "15px",
                    color: "#1B2466",
                    borderTop: "none",
                    borderLeft: "none",
                    borderRight: "none",
                    borderBottom:
                      rowIndex === data.length - 1
                        ? "none"
                        : "2px solid #1B2466",
                  }}
                >
                  {cell}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
